import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className="footer">
      <div className="pb-3"></div>
      {/* <div className="border"></div> */}
      <p className="pt-3">2023 © Copyright Reserved by PinkFeather Events Pvt. Ltd.</p>
      <div className="pb-3"></div>
    </div>
  );
}

export default Footer;
